"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SEARCH_TAG = void 0;
var SEARCH_TAG;
(function (SEARCH_TAG) {
    SEARCH_TAG["PHYSICIAN"] = "Phy:";
    SEARCH_TAG["INSURANCE"] = "Ins:";
})(SEARCH_TAG || (exports.SEARCH_TAG = SEARCH_TAG = {}));
